import { render } from "./BlockDetails.vue?vue&type=template&id=60fd9cdf&scoped=true"
import script from "./BlockDetails.vue?vue&type=script&lang=js"
export * from "./BlockDetails.vue?vue&type=script&lang=js"

import "./BlockDetails.vue?vue&type=style&index=0&id=60fd9cdf&scoped=true&lang=css"

import exportComponent from "/var/lib/jenkins/workspace/ignis-pha-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60fd9cdf"]])

export default __exports__